const { __ } = wp.i18n;

export default function ONGsItem({ id, title, logo, websiteLink }) {
  
  const link = websiteLink === '' || !websiteLink ? '#' : websiteLink;

  return (
    <>
      <a
        href={link}
        target={link === '#' ? '' : '_blank'} 
        className="item item-logo has-card-white-500-background-color">
        {logo && <img className="inner-logo" src={logo} loading="lazy" />}
        {websiteLink && (
          <span className="item-cta">
            <span className="wp-button is-underlined has-text-black-500-color">
              {__('Sitio Web', 'bizum-website')}
              <img src={`${scriptsData.themeUrl}/assets/images/icons-default/arrow-up-right.svg`} alt="Activar Bizum" className="icon-arrow-right" />
            </span>
          </span>
        )}
      </a>
    </>
  )

}